import { root, id } from './buckets';

export const buckets = {
  ...root,
  id,
};
